import { SystemSpaceSlug } from '@bettermode/common/space'

export const QUERY_SPACES_LIMIT_FOR_SEARCH = 20

export const DEFAULT_TREE_ITEM_LIMIT = 5

export const UTILITY_SPACE_SLUGS: SystemSpaceSlug[] = [
  SystemSpaceSlug.HOME,
  SystemSpaceSlug.MEMBER,
]
